module.exports = __webpack_public_path__ + "static/media/forsaleonamazon_1.18852a8f.jpg";